import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const DefaultRoute = ({ perms }) => {
    const location = useLocation();

    const to = perms?.[0]?.defaultRoute || '/my-assets';

    const finalTo = perms?.length ? to : '/';

    return (
        <Navigate
            to={finalTo}
            replace
            state={{ from: location }}
        />
    );
};

DefaultRoute.propTypes = {
    perms: PropTypes.arrayOf(
        PropTypes.shape({
            defaultRoute: PropTypes.string,
        })
    ),
};

const mapStateToProps = state => ({
    perms: state.user.perms,
});

export default connect(mapStateToProps)(DefaultRoute);
